function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Box } from '@adsk/alloy-react-box';
import { BasicButton } from '@adsk/alloy-react-button';
import { TriangleUpIcon, TriangleDownIcon, GearIcon } from '@adsk/alloy-react-icon';
import { useLocale } from '@adsk/alloy-react-locale';
import theme from '@adsk/alloy-react-theme';
import Tooltip, { Flyout } from '@adsk/alloy-react-tooltip';
import { useSideNavigation } from '@adsk/alloy-side-navigation';
import ProductLoader from './ProductLoader';
import ProductPicker from './ProductPicker';
import { productsListShape } from '../helpers/propTypes';
const StyledLabel = styled(Box).withConfig({
  displayName: "ProductButton__StyledLabel",
  componentId: "sc-sqk21k-0"
})(["", ""], {
  [theme.mediaQuery.small]: {
    display: 'none'
  }
});

// TODO - can be removed when account entitlement is available in V2
// TODO - verify it works as expected
const getProductIconV1 = product => {
  var _product$renderIcon;
  return product === null || product === void 0 ? void 0 : (_product$renderIcon = product.renderIcon) === null || _product$renderIcon === void 0 ? void 0 : _product$renderIcon.call(product, {
    size: 24,
    style: {
      color: theme.colors.adskBlue500
    }
  });
};
/**
 * Acs TopNavigation
 */
const ProductButton = _ref => {
  var _currentProduct$name;
  let {
    products,
    productId,
    required,
    renderCustomHeader,
    onProductClick
  } = _ref;
  const {
    T
  } = useLocale(_ref2 => {
    let {
      locale
    } = _ref2;
    return require("../i18n/".concat(locale, ".json"));
  });
  const {
    collapsed
  } = useSideNavigation();
  const [menuOpen, setMenuOpen] = useState(false);
  const PLACEHOLDER = {
    name: T.translate('PRODUCTS'),
    renderIcon: GearIcon.renderIcon,
    iconUrl: '',
    key: '',
    defaultUrl: ''
  };
  const currentProduct = (products === null || products === void 0 ? void 0 : products.find(product => product.key === productId)) || !required && PLACEHOLDER;
  const TriangleIconComponent = menuOpen ? TriangleUpIcon : TriangleDownIcon;
  return currentProduct ? /*#__PURE__*/React.createElement(Flyout, {
    show: menuOpen,
    onHide: () => setMenuOpen(false),
    onShow: () => setMenuOpen(true),
    offset: 15,
    renderBody: props => /*#__PURE__*/React.createElement(Tooltip.Body, _extends({}, props, {
      padding: 0
    })),
    placement: Flyout.PLACEMENTS.BOTTOM_START,
    renderTarget: props => /*#__PURE__*/React.createElement(Tooltip.Target, props),
    content: /*#__PURE__*/React.createElement(ProductPicker, {
      selectedId: productId,
      products: products,
      renderCustomHeader: renderCustomHeader,
      onClose: () => setMenuOpen(false),
      onProductClick: onProductClick
    })
  }, /*#__PURE__*/React.createElement(BasicButton, {
    onClick: () => setMenuOpen(!menuOpen),
    "data-testid": "TopNavigation__products",
    style: {
      padding: 0,
      width: !collapsed && 195,
      justifyContent: 'start',
      color: theme.colors.charcoal900,
      '&:hover': {
        color: theme.colors.charcoal700
      },
      [theme.mediaQuery.small]: {
        width: 'auto'
      }
    }
  }, /*#__PURE__*/React.createElement(Box, {
    display: "inline-flex",
    borderRadius: "4px",
    width: "32px",
    height: "32px",
    minWidth: "24px",
    bg: "adskBlue100",
    alignItems: "center",
    justifyContent: "center"
  }, currentProduct.iconUrl ? /*#__PURE__*/React.createElement(Box, {
    bg: "adskBlue500",
    width: "24px",
    height: "24px",
    style: {
      maskImage: "url(".concat(currentProduct.iconUrl, ")")
    }
  }) : getProductIconV1(currentProduct)), !collapsed && /*#__PURE__*/React.createElement(StyledLabel, _extends({}, ((_currentProduct$name = currentProduct.name) === null || _currentProduct$name === void 0 ? void 0 : _currentProduct$name.length) > 15 ? {
    typography: 'bodySmallBold',
    textAlign: 'left'
  } : {
    typography: 'bodyMediumBold'
  }, {
    paddingLeft: "8px",
    maxWidth: "250px"
  }), currentProduct.name), /*#__PURE__*/React.createElement(TriangleIconComponent, {
    style: {
      color: theme.colors.charcoal700,
      margin: '0 4px',
      [theme.mediaQuery.small]: {
        visibility: 'hidden'
      }
    },
    size: 20
  }))) : /*#__PURE__*/React.createElement(ProductLoader, null);
};
ProductButton.displayName = 'ProductButton';
ProductButton.defaultProps = {
  required: true
};
ProductButton.propTypes = {
  products: productsListShape,
  productId: PropTypes.string,
  required: PropTypes.bool,
  renderCustomHeader: PropTypes.func,
  onProductClick: PropTypes.func
};
export default ProductButton;
//# sourceMappingURL=ProductButton.js.map